import { memo } from 'react'

import { SecondaryMenuItemProps } from './MobileMenu.types'
import * as S from './MobileMenuRibbon.styles'

interface IProps {
  className?: string
  items: SecondaryMenuItemProps[]
}

const capitalize = (string: string) => string.charAt(0).toUpperCase() + string.slice(1)

// Keep this export clean, free of wrapping HOCs
export const _MobileMenuRibbon = ({ className, items }: IProps) => {
  return (
    <>
      <S.Root className={className}>
        <S.MenuItemsContainer>
          {items.map(item => (
            <S.MenuItem
              key={item.title}
              onClick={item.onClick}
              className={item.active ? 'active' : undefined}
            >
              {capitalize(item.title)}
            </S.MenuItem>
          ))}
        </S.MenuItemsContainer>
      </S.Root>
      <S.RibbonPlaceholder />
    </>
  )
}

// If you need to wrap this component with HOCs, use them here
export const MobileMenuRibbon = memo(_MobileMenuRibbon)
